import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import createHistory from "history/createBrowserHistory";
import { routerMiddleware } from "react-router-redux";
import { reducer as formReducer } from "redux-form";

import thunk from "redux-thunk";
import OccupationsReducer from "./reducers/OccupationsReducer";
import TasksReducer from "./reducers/TasksReducer";

import LoginReducer from "./reducers/LoginReducer";
import NotificationReducer from "./reducers/NotificationReducer";

export const history = createHistory();

const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const initialState = {};

const store = createStore(
  combineReducers({
    occupations: OccupationsReducer,
    form: formReducer,
    tasks: TasksReducer,
    login: LoginReducer,
    alert: NotificationReducer
  }),
  initialState,
  composedEnhancers
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js